import jQuery from 'jquery';
import $ from 'jquery';

// Full page slider jQuery plugin
// Author: Wakefly
// Purpose: Displays the selected elements in a full page slider. See `src/styles/components/_full-page-slider.scss` for accompanying styles
(function($) {
  $.fn.fullPageSlider = function(options) {

    /* Settings */
    const settings = $.extend({
      slidesSelector: '.section-hero',
      slideDuration: 250,
      wheelCooldownDuration: 250,
      wheelThreshhold: 50
    }, options);

    /* Selected elements */
    const $fullPageSlider = this;
    const $slides = $fullPageSlider.find(settings.slidesSelector);

    // State variables
    let activeSlideIndex = 0;
    let lastWheel = 0;

    /* Created elements */
    const $controlPrevious = $('<button type="button" class="full-page-slider-control-previous"><span class="sr-only">Previous slide</span></button>');
    const $controlNext = $('<button type="button" class="full-page-slider-control-next"><span class="sr-only">Next slide</span></button>');
    const $indicatorsWrapper = $('<div class="full-page-slider-indicators-wrapper"><div class="container"><ol class="full-page-slider-indicators"></ol></div></div>');
    const $alertMessage = $('<div class="full-page-slider-alert sr-only" role="alert"></div>')
    const $indicatorsList = $indicatorsWrapper.find('ol');
    $slides.each(function(index) {
      const $indicatorListItem = $('<li><button class="full-page-slider-indicator" type="button" data-slide-to="' + index + '"><span class="sr-only">View slide ' + (index + 1) + '</span></button></li>');
      $indicatorsList.append($indicatorListItem);
    });
    const $indicators = $indicatorsList.find('.full-page-slider-indicator');
  
    /* Events */
    // When indicator is clicked, activate it and its associated slide
    $indicators.click(function() {
      const slideIndex = $(this).data('slide-to');
      activateSlide(slideIndex);
    });

    // When previous button is clicked, navigate to the slide before the active slide
    $controlPrevious.click(function() {
      activateSlide(activeSlideIndex - 1);
    });

    // When next button is clicked, navigate to the slide after the active slide
    $controlNext.click(function() {
      activateSlide(activeSlideIndex + 1);
    });

    // When left/right arrow keys are pressed, navigate to the slide
    $fullPageSlider.keydown(function(event) {
      switch (event.key) {
        case 'Left':
        case 'ArrowLeft':
          activateSlide(activeSlideIndex - 1);
          break;
        case 'Right':
        case 'ArrowRight':
          activateSlide(activeSlideIndex + 1);
          break;
      }
    });
    $fullPageSlider.on('wheel', function(evt) {
      // Throttle the scroll events so we only change one slide at a time, and at a mimimum scrolling distance for trackpads
      if (Date.now() - lastWheel > settings.wheelCooldownDuration && Math.abs(evt.originalEvent.deltaY) > settings.wheelThreshhold) {
        // Adjust according to direction
        if (evt.originalEvent.deltaY < 0) {
          activateSlide(activeSlideIndex - 1);
        } else {
          activateSlide(activeSlideIndex + 1);
        }
        // log the current time to support throttling
        lastWheel = Date.now();
      }
    });
    
    /* Functions */
    // Activates the slide at the specified index
    function activateSlide(slideIndex) {
      var slideTitle = null;
      if (slideIndex >= 0 && slideIndex < $slides.length) {

        activeSlideIndex = slideIndex;

        const $activeSlide = $slides.eq(slideIndex);

        $activeSlide.addClass('active');
        $slides.not($activeSlide).removeClass('active');
        slideTitle = $activeSlide.data('title');
        $slides.addClass('sliding');

        $fullPageSlider.animate(
          { marginLeft: -(slideIndex * 100) + 'vw' },
          settings.slideDuration,
          'swing',
          function() { $slides.removeClass('sliding'); }
        );
      }

      updateControls(slideIndex, slideTitle);
    }

    // Updates the indicator and previous/next controls based on the slide Index
    function updateControls(slideIndex, slideTitle) {
      slideTitle = slideTitle == undefined ? null : slideTitle;
      if (slideIndex >= 0 && slideIndex < $slides.length) {

        const $activeIndicator = $indicators.eq(slideIndex);

        $activeIndicator
          .addClass('active')
          .attr('aria-pressed', 'true');

        $indicators.not($activeIndicator)
          .removeClass('active')
          .removeAttr('aria-pressed');

        if (slideIndex === 0) {
          $controlPrevious.attr('disabled', 'disabled');
          $controlPrevious.attr('aria-disabled', 'true');
        } else {
          $controlPrevious.removeAttr('disabled');
          $controlPrevious.removeAttr('aria-disabled');
        }

        if (slideIndex === $slides.length - 1) {
          $controlNext.attr('disabled', 'disabled');
          $controlNext.attr('aria-disabled', 'true');
        } else {
          $controlNext.removeAttr('disabled');
          $controlNext.removeAttr('aria-disabled');
        }

          $alertMessage.text('Full page slider showing slide ' + (slideIndex + 1) + ' of ' + $slides.length + (slideTitle ? ': ' + slideTitle : '') + '.');
      }
    }

    // Initializes the full page slider
    function initialize() {
      // Position controls strategically for keyboard focus order
      $fullPageSlider.find('main').before($controlPrevious);
      $fullPageSlider.append($controlNext);
      $fullPageSlider.append($indicatorsWrapper);
      $fullPageSlider.append($alertMessage);

      activateSlide(activeSlideIndex);

      // Plugin public members
      $fullPageSlider.activateSlide = activateSlide;
      $fullPageSlider.$slides = $slides;
      $fullPageSlider.$indicators = $indicators;
    }

    /* Setup */
    initialize();

    return $fullPageSlider;
  }
}(jQuery));

// Activate the plugin
const $fullPageSlider = $('.full-page-slider').fullPageSlider();

// HACK: When skip link anchors are clicked, activate an appropriate slide
$('a[href="#main"').click(function() {
  $fullPageSlider.activateSlide(0); // Main starts on the first slide
});
$('a[href="#footer"').click(function() {
  $fullPageSlider.activateSlide($fullPageSlider.$slides.length - 1); // Footer starts on the last slide
});